export const typography = {
  fontFamily: '"Assistant", "Helvetica", "Arial", sans-serif',
  h1: {
    fontWeight: 700,
    fontSize: '3rem',
  },
  h2: {
    fontWeight: 700,
    fontSize: '2.25rem',
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.75rem',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  h5: {
    fontWeight: 500,
    fontSize: '1.1rem',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1rem',
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.7,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
  },
  button: {
    fontWeight: 600,
    textTransform: 'none' as const,
  },
}
